/**
 * Remington 700, as a thing you can carry. The gun itself is `sim/weapons/guns/remington700.ts`.
 */

import { NO_ARMOR } from '@/sim/combat/armorMitigation';
import type { WeaponItem } from '@/sim/items/itemContract';

export const REMINGTON700_ITEM = {
  id: 'remington700',
  kind: 'weapon',
  label: 'Remington 700',
  description: 'One shot, one bolt throw, one long walk to see whether it worked.',
  rarity: 'rare',
  weightKg: 5.2,
  stackLimit: 1,
  equip: {
    slots: ['primaryWeapon'],
    statDeltas: {},
    armor: NO_ARMOR,
    damageModifiers: [],
  },
  weaponId: 'remington700',
} as const satisfies WeaponItem;
